import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime } from '../../../../actions/utilAction';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapAction, updateServiceCodeBlockedUnits } from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderTextArea, renderCheckBox, renderTimePicker, renderTextField, renderCustomRadioButtons } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureModal from './signature_modal';
import Alert from 'react-s-alert';
import validate from './validate';


//const validateNotes = (value) => !value ? 'Please enter notes.' : undefined;

class SessionNotes_BT_BESTABA extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      // isAdminUpdateAfterRendered: false,

      // checkbox handling
      isPresenceDuringCheckAllowed: true,
      isEBIUAllowed: true,
      isProgramAreasWorkedOnAllowed: true,
      IsTreatmentGoal: null,
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);
    this.changeIsTreatmentGoal = this.changeIsTreatmentGoal.bind(this);
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    this.props.getAppConfigList();
  }

  handleCancel() {
    history.push('/scheduling');
  }

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });
      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId ? true : false,
        signatureStaffs: signatureStaffs,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered') {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
              case 'CLINICIAN_SIGN':
                employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'PATIENT_SIGN':
                client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'GUARDIAN_SIGN':
                guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              default:
                break;
            }
          }
        });
      }

      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {
        if (!this.state.encounterId) {
          history.push(`/session-bt-bestaba/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSoapCompleted: true });
        }
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: this.state.appointmentTypeIsBillable ? true : false });
      }
    }
    
    if(this.props.match.params.encId > 0 && nextProps.IsTreatmentGoal !== this.props.IsTreatmentGoal){
       this.setState({IsTreatmentGoal: nextProps.IsTreatmentGoal || 0 },()=>{this.changeIsTreatmentGoal(null,nextProps.IsTreatmentGoal || 0)});      
    }

    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onCompleteSoap(formProps) {
    this.setState({ isGenerateClaimAfterRendered: false });
    let isGenerateClaim = true;
    this.submitFormData(formProps, isGenerateClaim);
  }

  onSubmit(formProps) {
    this.submitFormData(formProps);
  };

  submitFormData(formProps, isGenerateClaim = false) {
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 1,
      'SessionNotes_BT_BESTABA': {
        'Id': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
        'IsTreatmentGoal': formProps.IsTreatmentGoal || 0,
        'Notes': formProps.notes,
        'BT_PresentDuringSession_BESTABA': {
          'PresentDuringSessionId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA && this.state.get_soap.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
          'ParentsOrGuardian': formProps.ParentsOrGuardian || 0,
          'BCBAOrBCaBA': formProps.BCBAOrBCaBA || 0,
          'SiblingsOrPeer': formProps.SiblingsOrPeer || 0,
          'Client': formProps.Client || 0,
          'OtherBT': formProps.OtherBT || 0,
          'OtherBTNotes': formProps.OtherBT ? formProps.OtherBTNotes : '',
        },
        'BT_EvidenceBasedInterventionsUsed_BESTABA': {
          'InterventionsUsedToAddressId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA && this.state.get_soap.sessionNotes_BT_BESTABA.BT_EvidenceBasedInterventionsUsed_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.BT_EvidenceBasedInterventionsUsed_BESTABA.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
          'AntecedentInterventions': formProps.AntecedentInterventions || 0,
          'DifferentialReinforcement': formProps.DifferentialReinforcement || 0,
          'DTT': formProps.DTT || 0,
          'Extinction': formProps.Extinction || 0,
          'Modeling': formProps.Modeling || 0,
          'TAOrChaining': formProps.TAOrChaining || 0,
          'VideoModeling': formProps.VideoModeling || 0,
          'VisualSupport': formProps.VisualSupport || 0,
          'Reinforcement': formProps.Reinforcement || 0,
          'SelfManagement': formProps.SelfManagement || 0,
          'SocialNarratives': formProps.SocialNarratives || 0,
          'SocialSkillsTraining': formProps.SocialSkillsTraining || 0,
          'FCT': formProps.FCT || 0,
          'NET': formProps.NET || 0,
          'PromptingAndPromptFading': formProps.PromptingAndPromptFading || 0,
          'Baseline': formProps.Baseline || 0,
          'RapportBuildingOrPairing': formProps.RapportBuildingOrPairing || 0,
          'TokenEconomy': formProps.TokenEconomy || 0,
          'BehavioralMomentum': formProps.BehavioralMomentum || 0,
          'Other': formProps.OtherBT2 || 0,
          'OtherNotes': formProps.OtherBT2 ? formProps.OtherBTNotes2 : '',
        },
        'BT_ProgramAreasWorked_BESTABA': {
          'ProgramAreasWorkedId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA && this.state.get_soap.sessionNotes_BT_BESTABA.BT_ProgramAreasWorked_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.BT_ProgramAreasWorked_BESTABA.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
          'Communication': formProps.Communication || 0,
          'ADLs': formProps.ADLs || 0,
          'SocialSkills': formProps.SocialSkills || 0,
          'ProblemBehavior': formProps.ProblemBehavior || 0,
          'SafetySkills': formProps.SafetySkills || 0,
          'PlayOrLeisure': formProps.PlayOrLeisure || 0,
          'SelfManagementRegulation': formProps.SelfManagementRegulation || 0,
          'ToleranceOfNoveltyOrChange': formProps.ToleranceOfNoveltyOrChange || 0,
          'Other': formProps.OtherBT3 || 0,
          'OtherNotes': formProps.OtherBT3 ? formProps.OtherBTNotes3 : '',
        },
        'BT_BehaviorOrInstructionalChallengesPresent_BESTABA': {
          'BehaviorChallengesPresentId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA && this.state.get_soap.sessionNotes_BT_BESTABA.BT_BehaviorOrInstructionalChallengesPresent_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.BT_BehaviorOrInstructionalChallengesPresent_BESTABA.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
          'Aggression': formProps.Aggression || 0,
          'NonCompliance': formProps.NonCompliance || 0,
          'Elopement': formProps.Elopement || 0,
          'PropertyDestruction': formProps.PropertyDestruction || 0,
          'SIB': formProps.SIB || 0,
          'LackOfMotivation': formProps.LackOfMotivation || 0,
          'Inattention': formProps.Inattention || 0,
          'ObsessiveOrPerseverative': formProps.ObsessiveOrPerseverative || 0,
          'Other': formProps.OtherBT4 || 0,
          'OtherNotes': formProps.OtherBT4 ? formProps.OtherBTNotes4 : '',
        },
        'BT_InterventionsUsedToAddress_BESTABA': {
          'InterventionsUsedToAddressId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA && this.state.get_soap.sessionNotes_BT_BESTABA.BT_InterventionsUsedToAddress_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.BT_InterventionsUsedToAddress_BESTABA.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_BESTABA ? this.state.get_soap.sessionNotes_BT_BESTABA.id : 0,
          'FollowedBSP': formProps.FollowedBSP || 0,
          'ABCData': formProps.ABCData || 0,
          'ConsultedWithBCBA': formProps.ConsultedWithBCBA || 0,
          'Other': formProps.OtherBT5 || 0,
          'OtherNotes': formProps.OtherBT5 ? formProps.OtherBTNotes5 : '',
        }
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
    };
    // console.log('submit data =========',formData);
    let presenceDuringCheckPermission = false;
    let EBIUPermission = false;
    let programAreasWorkedOnPermission = false;

    // Check directly formData
    if(formData.SessionNotes_BT_BESTABA.BT_PresentDuringSession_BESTABA) {
        let presenceDuringCheck = formData.SessionNotes_BT_BESTABA.BT_PresentDuringSession_BESTABA;
        let EBIU = formData.SessionNotes_BT_BESTABA.BT_EvidenceBasedInterventionsUsed_BESTABA;
        let programAreasWorkedOn = formData.SessionNotes_BT_BESTABA.BT_ProgramAreasWorked_BESTABA;

        // For Present During Session
        if(presenceDuringCheck.ParentsOrGuardian === 0 && presenceDuringCheck.BCBAOrBCaBA === 0 && presenceDuringCheck.SiblingsOrPeer === 0 && presenceDuringCheck.Client === 0 && presenceDuringCheck.OtherBT === 0) {
          presenceDuringCheckPermission = false;
          this.setState({ isPresenceDuringCheckAllowed: false });
        } else {
          presenceDuringCheckPermission = true;
          this.setState({ isPresenceDuringCheckAllowed: true });
        }

        // For Evidence-based Intervention Used
        if(EBIU.AntecedentInterventions === 0 && EBIU.Baseline === 0 && EBIU.BehavioralMomentum === 0 && EBIU.DTT === 0 && EBIU.DifferentialReinforcement === 0 && EBIU.Extinction === 0 && EBIU.FCT === 0 && EBIU.Modeling === 0 && EBIU.NET === 0 && EBIU.Other === 0 && EBIU.PromptingAndPromptFading === 0 && EBIU.RapportBuildingOrPairing === 0 && EBIU.Reinforcement === 0 && EBIU.SelfManagement === 0 && EBIU.SocialNarratives === 0 && EBIU.SocialSkillsTraining === 0 && EBIU.TAOrChaining === 0 && EBIU.TokenEconomy === 0 && EBIU.VideoModeling === 0 && EBIU.VisualSupport === 0) {
          EBIUPermission = false;
          this.setState({ isEBIUAllowed : false })
        } else {
          EBIUPermission = true;
          this.setState({ isEBIUAllowed: true })
        }

        // For Program Areas Worked on
        if(programAreasWorkedOn.Communication === 0 && programAreasWorkedOn.ADLs === 0 && programAreasWorkedOn.SocialSkills === 0 && programAreasWorkedOn.ProblemBehavior === 0 && programAreasWorkedOn.SafetySkills === 0 && programAreasWorkedOn.PlayOrLeisure === 0 && programAreasWorkedOn.SelfManagementRegulation === 0 && programAreasWorkedOn.ToleranceOfNoveltyOrChange === 0 && programAreasWorkedOn.Other === 0) {
          programAreasWorkedOnPermission = false;
          this.setState({ isProgramAreasWorkedOnAllowed : false })
        } else {
          programAreasWorkedOnPermission = true;
          this.setState({ isProgramAreasWorkedOnAllowed : true })
        }
        
    }
  
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    if(presenceDuringCheckPermission === true && EBIUPermission === true && programAreasWorkedOnPermission === true) {
      this.props.savePatientSoapAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
    } else {
      Alert.error('Please fill therapy session notes details!', {
        position: 'bottom-right',
        effect: 'slide',
      });
    }
  }

  changeIsTreatmentGoal = (e, value) => {    
    this.setState({ IsTreatmentGoal: parseInt(value || 0, 10)});
  };

  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };
  handleOpenSign = () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true, soapPage: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick = (e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
  CPTCodeAlertClick = (e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
      //   actionName: 'Delete',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr });
    }
  }
  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      // let data = {
      //   index: index,
      //   AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      // };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <td width="10%"><button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
            : null} */}
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues) => {
    if (formValues.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
      //   actionName: 'Add',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.CPTID);
    let arr = this.state.CPTTableData;
    if (arr.indexOf(cptObj) === -1) {
      arr.push({
        'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
        'AuthorizationNumber': formValues.AuthorizationNumber,
        'ServiceCodeId': cptObj.id,
        'ServiceCode': cptObj.serviceCode,
        'Description': cptObj.description,
        'IsDeleted': false,
        'Id': 0,
        'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
        'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
        'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
        'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
      });
      this.setState({ CPTTableData: arr });
    }
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
      case 1:
        data.id = this.state.EmployeeSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ EmployeeSign: data });
        this.filter.isEmployeeSigned = true;
        this.saveEncounterSigns(data.id, data, null, null);
        break;
      case 2:
        data.id = this.state.ClientSign.id || null;
        data.Name = this.state.patientName;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ ClientSign: data });
        this.filter.isClientSigned = true;
        this.saveEncounterSigns(data.id, null, data, null);
        break;
      case 3:
        data.id = this.state.GuardianSign.id || null;
        data.Name = formProps.Guardian;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ GuardianSign: data });
        this.filter.isGuardianSigned = true;
        this.saveEncounterSigns(data.id, null, null, data);
        break;
      default:
        break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }
    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed) {
      return true;
    } else {
      return false;
    }
  }

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }
  
  render() {
    const { handleSubmit } = this.props;
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage={this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage={this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT={this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} />
          : null}
        {this.state.openSign ?
          <SignatureModal staffID={this.state.staffID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="row">
                <div className="col-12">
                    {this.state.isGenerateClaimAfterRendered ?
                      <div className={'alert alert-danger-soap update-pwd'}>
                        <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                      </div>
                      :
                      <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                    } 
                  </div>
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p> */}
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Therapy Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Present during session</h5><span style={{ color: 'red'}}>*</span>
                    {!this.state.isPresenceDuringCheckAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ParentsOrGuardian"
                    label="Parents/ Guardian"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BCBAOrBCaBA"
                    label="BCBA/ BCaBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SiblingsOrPeer"
                    label="Siblings/ Peer"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Client"
                    label="Client"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT &&
                  (<div className='col-sm-4'>
                  <Field
                    name="OtherBTNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Evidence-based interventions used</h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isEBIUAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AntecedentInterventions"
                    label="Antecedent interventions"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifferentialReinforcement"
                    label="Differential reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DTT"
                    label="DTT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Extinction"
                    label="Extinction"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Modeling"
                    label="Modeling"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TAOrChaining"
                    label="TA / Chaining"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VideoModeling"
                    label="Video modeling"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VisualSupport"
                    label="Visual support"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SelfManagement"
                    label="Self-management"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialNarratives"
                    label="Social narratives"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkillsTraining"
                    label="Social Skills Training"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FCT"
                    label="FCT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="NET"
                    label="NET"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PromptingAndPromptFading"
                    label="Prompting and prompt fading"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Baseline"
                    label="Baseline"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RapportBuildingOrPairing"
                    label="Rapport Building/pairing"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TokenEconomy"
                    label="Token Economy"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehavioralMomentum"
                    label="Behavioral momentum"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT2"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT2 &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherBTNotes2"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Program Areas worked on</h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isProgramAreasWorkedOnAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Communication"
                    label="Communication"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ADLs"
                    label="ADLs"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkills"
                    label="Social Skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProblemBehavior"
                    label="Problem Behavior"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SafetySkills"
                    label="Safety Skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PlayOrLeisure"
                    label="Play / Leisure"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SelfManagementRegulation"
                    label="Self-monitoring"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ToleranceOfNoveltyOrChange"
                    label="Tolerance of novelty / change"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT3"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT3 &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherBTNotes3"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Behavior / Instructional challenges present</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Aggression"
                    label="Aggression"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="NonCompliance"
                    label="Non-compliance"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Elopement"
                    label="Elopement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PropertyDestruction"
                    label="Property Destruction"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SIB"
                    label="SIB"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="LackOfMotivation"
                    label="Lack of motivation"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Inattention"
                    label="Inattention"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObsessiveOrPerseverative"
                    label="Obsessive/ perseverative"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT4"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT4 &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherBTNotes4"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Interventions used to address</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FollowedBSP"
                    label="Followed BSP"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ABCData"
                    label="ABC Data"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ConsultedWithBCBA"
                    label="Consulted with BCBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT5"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT5 &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherBTNotes5"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20">
                    <h5>Did the client demonstrate progress towards treatment goals:</h5>
                  </div>
                  <Field name="IsTreatmentGoal"
                    options={[{ id: 1, value: 'Yes' }, { id: 0, value: 'No' }]}
                    selectedValue={this.state.IsTreatmentGoal}
                    onChange={this.changeIsTreatmentGoal}
                    disabled={this.state.isSoapCompleted}
                    component={renderCustomRadioButtons} />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12'>
                  <Field
                    name="notes"
                    type="text"
                    fullWidth={true}
                    label="Notes"
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                  />
                </div>
              </div>
            
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Diagnosis</h3>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                    <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Service Codes</h3>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>
                : null} */}
            </div>
            <div className="mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null} */}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted ?
                  (<span>
                    {this.state.showCompleteButton ?
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={handleSubmit(this.onCompleteSoap)} />
                      : <CommonButton onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>

            {this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('soapForm');
SessionNotes_BT_BESTABA = reduxForm({
  form: 'soapForm',
  validate,
  enableReinitialize: true,
})(SessionNotes_BT_BESTABA);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    if (obj.sessionNotes_BT_BESTABA) {
      initialData = {
        IsTreatmentGoal: obj.sessionNotes_BT_BESTABA.isTreatmentGoal === true ? 1 : 0,
        notes: obj.sessionNotes_BT_BESTABA.notes,
        // bT_PresentDuringSession_BESTABA
        ParentsOrGuardian: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.parentsOrGuardian,
        BCBAOrBCaBA: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.bcbaOrBCaBA,
        SiblingsOrPeer: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.siblingsOrPeer,
        Client: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.client,
        OtherBT: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.otherBT,
        OtherBTNotes: obj.sessionNotes_BT_BESTABA.bT_PresentDuringSession_BESTABA.otherBTNotes,
        // BT_EvidenceBasedInterventionsUsed_BESTABA
        AntecedentInterventions: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.antecedentInterventions,
        DifferentialReinforcement: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.differentialReinforcement,
        DTT: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.dtt,
        Extinction: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.extinction,
        Modeling: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.modeling,
        TAOrChaining: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.taOrChaining,
        VideoModeling: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.videoModeling,
        VisualSupport: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.visualSupport,
        Reinforcement: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.reinforcement,
        SelfManagement: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.selfManagement,
        SocialNarratives: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.socialNarratives,
        SocialSkillsTraining: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.socialSkillsTraining,
        FCT: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.fct,
        NET: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.net,
        PromptingAndPromptFading: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.promptingAndPromptFading,
        Baseline: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.baseline,
        RapportBuildingOrPairing: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.rapportBuildingOrPairing,
        TokenEconomy: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.tokenEconomy,
        BehavioralMomentum: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.behavioralMomentum,
        OtherBT2: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.other,
        OtherBTNotes2: obj.sessionNotes_BT_BESTABA.bT_EvidenceBasedInterventionsUsed_BESTABA.otherNotes,
        // BT_ProgramAreasWorked_BESTABA
        Communication: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.communication,
        ADLs: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.adLs,
        SocialSkills: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.socialSkills,
        ProblemBehavior: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.problemBehavior,
        SafetySkills: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.safetySkills,
        PlayOrLeisure: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.playOrLeisure,
        SelfManagementRegulation: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.selfManagementRegulation,
        ToleranceOfNoveltyOrChange: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.toleranceOfNoveltyOrChange,
        OtherBT3: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.other,
        OtherBTNotes3: obj.sessionNotes_BT_BESTABA.bT_ProgramAreasWorked_BESTABA.otherNotes,
        // BT_BehaviorOrInstructionalChallengesPresent_BESTABA
        Aggression: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.aggression,
        NonCompliance: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.nonCompliance,
        Elopement: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.elopement,
        PropertyDestruction: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.propertyDestruction,
        SIB: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.sib,
        LackOfMotivation: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.lackOfMotivation,
        Inattention: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.inattention,
        ObsessiveOrPerseverative: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.obsessiveOrPerseverative,
        OtherBT4: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.other,
        OtherBTNotes4: obj.sessionNotes_BT_BESTABA.bT_BehaviorOrInstructionalChallengesPresent_BESTABA.otherNotes,

        // BT_InterventionsUsedToAddress_BESTABA
        FollowedBSP: obj.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.followedBSP,
        ABCData: obj.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.abcData,
        ConsultedWithBCBA: obj.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.consultedwithBCBA,
        OtherBT5: obj.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.other,
        OtherBTNotes5: obj.sessionNotes_BT_BESTABA.bT_InterventionsUsedToAddress_BESTABA.otherNotes,
      };
    }
  }

  return {
    selectorOtherBT: selector(state, 'OtherBT'),
    selectorOtherBT2: selector(state, 'OtherBT2'),
    selectorOtherBT3: selector(state, 'OtherBT3'),
    selectorOtherBT4: selector(state, 'OtherBT4'),
    selectorOtherBT5: selector(state, 'OtherBT5'),

    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    IsTreatmentGoal: state.soap.get_soap && state.soap.get_soap.data && state.soap.get_soap.data.sessionNotes_BT_BESTABA ? state.soap.get_soap.data.sessionNotes_BT_BESTABA.isTreatmentGoal === true ? 1 : 0 : null,
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation })(SessionNotes_BT_BESTABA);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_BT_BESTABA/index.js